'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Skeleton_module = require('../styles/Skeleton.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

function validWidth(width) {
    if (!width || width < 0) {
        return 100;
    }
    if (width > 100) {
        return 100;
    }
    return width;
}
/**
 * @description Skeleton Paragraph component.
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton.Paragraph />
 * ```
 */
const Paragraph = (props) => {
    const { width, className, inverted = false, ...restProps } = props;
    const cx = reactUtils.useStyles(Skeleton_module.default);
    const classNames = cx(className, 'paragraph', { inverted });
    const elementStyles = {
        width: `${validWidth(width)}%`,
    };
    return React__namespace.createElement("div", { className: classNames, ...restProps, style: elementStyles });
};
Paragraph.displayName = 'Paragraph';

exports.Paragraph = Paragraph;
//# sourceMappingURL=Paragraph.js.map
